// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__iN-UA","subheading":"styles_subheading__XxSMx","logos":"styles_logos__9R1Y2"};